@app.directive 'pageNavJoule', ->
  restrict: 'E'
  scope: {}
  controllerAs: 'pageNavJoule'
  controller: ->


    this

  link: (scope, element, attrs) ->

  bindToController: {
    theme: '='
    content: '='
  }
  templateUrl: "/assets/templates/components/pageNav/pageNavJoule/pageNavJoule.html"
